import AbstractComponent from './AbstractComponent';
import smoothscroll from 'smoothscroll-polyfill';

/**
 * Manages the go to component.
 */
export default class GoTo extends AbstractComponent {
  /**
   * The HTML element of the wrapper.
   */
  private $wrapper: HTMLElement;

  /**
   * The HTML element of the target of the link.
   */
  private $target: HTMLElement;

  /**
   * The HTML element of the link.
   */
  private $link: HTMLAnchorElement;

  /**
   * Creates the go to component.
   *
   * @param $wrapper The `.go-to` element
   */
  constructor($wrapper: HTMLElement) {
    super();

    smoothscroll.polyfill();

    this.$wrapper = $wrapper;
  }

  /**
   * Initializes the go to component.
   */
  public initialize(): void {
    this.$link = this.$wrapper.querySelector('.go-to__link');
    this.$target = document.querySelector(this.$link.hash);

    this.$link.addEventListener('click', (event) => {
      this.onLinkClicked(event);
    });
  }

  /**
   * Called when the user clicks on the link.
   *
   * @param event The event arguments
   */
  private onLinkClicked(event: MouseEvent): void {
    event.preventDefault();

    this.$target.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
